var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isNavigation ? [_c("navigation")] : _vm._e(),
      _vm._v(" "),
      _c("loader", { class: { "loader-hidden": !_vm.isLoading } }),
      _vm._v(" "),
      _c("notifications", { attrs: { group: "app", position: "top center" } }),
      _vm._v(" "),
      _c("router-view")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }